export default __webpack_public_path__ + "static/media/Ship.cb848ba5.png";